module.exports = __webpack_public_path__ + "img/2100m.85223e6c.png";